import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeatureGrid from './components/FeatureGrid';
import AdminDashboard from './components/AdminDashboard';
import GuestDemo from './components/GuestDemo';
import Metrics from './components/Metrics';
import Footer from './components/Footer';

export default function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    document.body.className = theme === 'dark' ? 'bg-black text-white' : 'bg-white text-black';
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  return (
    <div className={`min-h-screen flex flex-col transition-colors duration-500 overflow-x-hidden ${theme === 'dark' ? 'bg-black text-white' : 'bg-white text-black'}`}>
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <main className="flex-grow">
        <Hero theme={theme} />

        {/* The Essence of Kypser */}
        <section id="features" className="py-32 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-4xl mb-24">
              <h2 className={`text-4xl md:text-6xl font-bold tracking-tight mb-8 ${theme === 'dark' ? 'text-white' : 'text-black'}`}>
                Operating at the speed of thought.
              </h2>
              <p className={`text-xl md:text-2xl leading-relaxed max-w-2xl ${theme === 'dark' ? 'text-zinc-400' : 'text-zinc-500'}`}>
                Kypser is a sophisticated operational layer that handles everything from routine guest questions to complex requests, so your team can focus on what matters: hospitality.
              </p>
            </div>
            <FeatureGrid theme={theme} />
          </div>
        </section>

        {/* The Platform Experience */}
        <section id="platform" className={`py-32 relative overflow-hidden transition-colors duration-500 ${theme === 'dark' ? 'bg-zinc-950' : 'bg-zinc-50'}`}>
          <div className={`absolute top-0 left-1/2 -translate-x-1/2 w-full h-[1px] ${theme === 'dark' ? 'bg-gradient-to-r from-transparent via-zinc-800 to-transparent' : 'bg-gradient-to-r from-transparent via-zinc-200 to-transparent'}`}></div>

          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-col items-center mb-20 text-center">
              <div className={`inline-flex p-1 rounded-full mb-12 border transition-colors duration-500 ${theme === 'dark' ? 'bg-zinc-900 border-zinc-800' : 'bg-zinc-200 border-zinc-300'}`}>
                <button
                  onClick={() => setActiveTab('dashboard')}
                  className={`px-8 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${activeTab === 'dashboard' ? (theme === 'dark' ? 'bg-white text-black' : 'bg-black text-white') : (theme === 'dark' ? 'text-zinc-500 hover:text-white' : 'text-zinc-600 hover:text-black')}`}
                >
                  Admin Panel
                </button>
                <button
                  onClick={() => setActiveTab('concierge')}
                  className={`px-8 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 ${activeTab === 'concierge' ? (theme === 'dark' ? 'bg-white text-black' : 'bg-black text-white') : (theme === 'dark' ? 'text-zinc-500 hover:text-white' : 'text-zinc-600 hover:text-black')}`}
                >
                  Guest Interface
                </button>
              </div>

              <div className="w-full">
                {activeTab === 'dashboard' ? <AdminDashboard theme={theme} /> : <GuestDemo theme={theme} />}
              </div>
            </div>
          </div>
        </section>

        <section className="py-32">
          <Metrics theme={theme} />
        </section>

        {/* Global CTA */}
        <section className={`py-40 border-t transition-colors duration-500 ${theme === 'dark' ? 'border-zinc-900 bg-black' : 'border-zinc-200 bg-zinc-50'}`}>
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h2 className={`text-5xl md:text-8xl font-bold mb-12 tracking-tighter ${theme === 'dark' ? 'text-gradient-dark' : 'text-gradient-light'}`}>
              Upgrade your <br /> hospitality today.
            </h2>
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
              <a href="mailto:info@kypser.com?subject=Start%20for%20Free" className={`px-10 py-5 font-bold rounded-full hover:scale-105 transition-transform text-lg ${theme === 'dark' ? 'bg-white text-black' : 'bg-black text-white shadow-xl'}`}>
                Start for Free
              </a>
              <a href="mailto:info@kypser.com?subject=Book%20a%20Demo" className={`px-10 py-5 font-bold rounded-full border transition-colors text-lg ${theme === 'dark' ? 'bg-zinc-900 text-white border-zinc-800 hover:bg-zinc-800' : 'bg-white text-black border-zinc-200 hover:bg-zinc-100'}`}>
                Book a Demo
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer theme={theme} />
    </div>
  );
}

